import React from 'react';
import Image from "./Components/Image";
import Images from "./Components/Images";
import './App.less';

const sponsorIcons = [
    <Image src={Images.sponsorA} />,
    <Image src={Images.sponsorB} />,
    <Image src={Images.sponsorC} />,
    <Image src={Images.sponsorD} />,
    <Image src={Images.sponsorE} />,
];

function App() {

  return (
    <div className="main-container">
        <div className={'background-img'}>
            <Image src={'https://dropship-media-test.s3.us-east-1.amazonaws.com/calc_test/promo_pages/install_page/build/static/media/bg-min.a3b9079a.png'} />
        </div>
        <div className="content">
            <div className={'title-wrapper'}>
                <h2>
                    Thanks for installing the
                    Dropship browser extension
                    How it works?
                </h2>
            </div>
            <div className="extension-preview-img">
                <Image src={'https://dropship-media-test.s3.us-east-1.amazonaws.com/calc_test/promo_pages/install_page/build/static/media/banner-min.d7bfdf66.png'} />
            </div>
            <div className="ad-spend-analysis">
                <div className="text-wrapper">
                    <h3>
                        Facebook ad spend analysis
                    </h3>
                    <p>
                        Access real-time ad spend, reach and audience insights directly inside Facebook Ad Library. Download ad creatives instantly and open full analytics in Dropship - all in one click.
                    </p>
                </div>
                <div className="image-wrapper">
                    <Image src={'https://dropship-media-test.s3.us-east-1.amazonaws.com/calc_test/promo_pages/install_page/build/static/media/ad_spend-min.1808d79e.png'} />
                </div>
            </div>
            <div className="ad-spend-analysis">
                <div className="image-wrapper">
                    <Image src={'https://dropship-media-test.s3.us-east-1.amazonaws.com/calc_test/promo_pages/install_page/build/static/media/store_intelligence-min.d864d3a7.png'} />
                </div>
                <div className="text-wrapper">
                    <h3>
                        Instant Shopify store intelligence
                    </h3>
                    <p>
                        Explore any Shopify store in one view - from catalog details and ad performance to audience insights. See which apps power the store and uncover data-driven advantages instantly.
                    </p>
                </div>
            </div>
            <div className="ad-spend-analysis">
                <div className="text-wrapper">
                    <h3>
                        One-click import to Shopify
                    </h3>
                    <p>
                        Import any product on your Shopify store with just one-click to save time.
                    </p>
                </div>
                <div className="image-wrapper">
                    <Image src={'https://dropship-media-test.s3.us-east-1.amazonaws.com/calc_test/promo_pages/install_page/build/static/media/import-min.e56ff16e.png '} />
                </div>
            </div>
        </div>
        <div className="sponsors">
            <div className={'line'} />
            <span>
                APPLICABLE TO ALL SELLERS
            </span>
            <div className={'line'} />
        </div>
        <div className="sponsors-wrapper">
            {
                sponsorIcons.map((el, index) => <div key={index}>{el}</div>)
            }
        </div>
    </div>
  );
}

export default App;
